import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CollapseIcon from 'Shared/assets/icons/collapse.svg';
import ExpandIcon from 'Shared/assets/icons/expand.svg';
import { getDatasetFullLabel } from 'Common/utils';
import ErrorMessage from 'Common/components/ErrorMessage/ErrorMessage';
import { fetchAPIData } from 'PhenotypeCatalogueView/store/actions';
import { getDataCollection, getErrorCollection } from 'PhenotypeCatalogueView/store/selectors';
import TreeItem from '../TreeItem/TreeItem';
import { TreeViewSkeleton } from '../TreeViewSkeleton';
import styles from './CatalogueTree.css';
const CatalogueTreeContainer = ({ provider, datasetVersionId, datasetName, }) => {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(false);
    const showMoreIcon = expanded ? _jsx(CollapseIcon, {}, void 0) : _jsx(ExpandIcon, {}, void 0);
    const error = useSelector(getErrorCollection)[datasetVersionId];
    const datasetData = useSelector(getDataCollection)[datasetVersionId];
    const handleClickButton = () => {
        setExpanded(!expanded);
        if (!datasetData) {
            dispatch(fetchAPIData({ versionIds: [datasetVersionId] }));
        }
    };
    const errorMessage = (_jsx(ErrorMessage, { className: styles.error, title: "Attention", message: "The content is currently unavailable. Please reload the page or try again later." }, void 0));
    return (_jsxs("div", Object.assign({ className: styles.container }, { children: [_jsxs("button", Object.assign({ type: "button", onClick: handleClickButton, className: styles.expandButton, "data-testid": `tree-item-button-${datasetVersionId}` }, { children: [_jsx("div", Object.assign({ className: styles.icon }, { children: showMoreIcon }), void 0), _jsx("span", Object.assign({ className: styles.name }, { children: getDatasetFullLabel(provider, datasetName) }), void 0)] }), void 0), expanded && (_jsxs("div", Object.assign({ className: styles.list }, { children: [error && errorMessage, !error
                        && !datasetData
                        && (_jsx(TreeViewSkeleton, {}, void 0)), !error
                        && !!(datasetData === null || datasetData === void 0 ? void 0 : datasetData.data)
                        && datasetData.data.map((item) => (_jsx(TreeItem, { id: item.id, datasetVersionId: datasetVersionId, name: item.name, data: item.data, bold: item.bold }, item.id)))] }), void 0))] }), void 0));
};
export default memo(CatalogueTreeContainer);
